import { getUserToken } from '../../../../helpers/authUtils';
import { GetNotifications } from "../";

// As this is a thunk, it is a function which returns a function.
const dismissNotification_thunk = (notificationUserId) => {
    return (dispatch, getState) => {
        dismissNotification(dispatch, notificationUserId);        
    };
};

const dismissNotification = (dispatch, notificationUserId) => {
    let url = `/portal/Notifications/NotificationDismissed?notificationUserId=${notificationUserId}`;
    
    let options = {
        ...{
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'accept': 'application/json',
                'Authorization': 'Bearer ' + getUserToken()
            }
        }
    };
    
    fetch(url, options)
        .then(response => {
            if (response.ok) { return response.json(); }
            else { throw new Error(response); }
        })
        .then(data => {
            dispatch(GetNotifications(true));
        })
        .catch(error => {
            dispatch(GetNotifications(true));
        });
};

export default dismissNotification_thunk;
